import { useState } from "react";
import CLogo from "components/CLogo";
import CAvatar from "components/CAvatar";
import { useParams } from "react-router-dom";
import CCustomLogo from "components/CCustomLogo";
import color from "context/MaterialUITheme/color";
import { Turn as Hamburger } from "hamburger-react";
import CFaqsButton from "./CButtonsHeader/CFaqsButton";
import useInvite from "context/Invite/useInviteContext";
import FortunaLogo from "assets/Images/Fortuna-logo.png";
import CLoginButton from "./CButtonsHeader/CLoginButton";
import useTracker from "components/CTracker/useTrackerContext";
import { Box, Drawer, Toolbar, Container } from "@mui/material";
import CContactusButton from "./CButtonsHeader/CContactusButton";
import useUser from "context/UserCustomer/useUserCustomerContext";
import CGetintouchButton from "./CButtonsHeader/CGetintouchButton";
import CForlendersButton from "./CButtonsHeader/CForlendersButton";
import CContactusGladlyButton from "./CButtonsHeader/CContactusGladlyButton";

const CHeader = () => {
  const [opened, setOpened] = useState(false);
  const { user } = useUser();
  const invite = useInvite();
  const params = useParams();
  const { loan } = useTracker();
  const sourceId = params["sourceId"];

  const logo = invite?.broker?.logo
    ? invite?.broker?.logo
    : loan?.broker?.logo
    ? loan?.broker?.logo
    : sourceId
    ? "fortuna"
    : "NFTYDoor";
  const link = invite?.broker?.web ? invite?.broker?.web : "";

  const pathname = window.location.pathname;

  const isLongHeader =
    pathname === "/" ||
    pathname === "/faqs" ||
    pathname === "/lenders" ||
    pathname === "*";

  const isLender = pathname === "/lenders";
  const isLogin = pathname === "/login";

  const isSignupForm =
    pathname.slice(pathname.length - 6, pathname.length) === "signup";

  const isTracker =
    pathname === "/borrower-tracker" || pathname === "/coborrower-tracker";

  return (
    <Box
      top={0}
      zIndex={100}
      position="sticky"
      display={"flex"}
      justifyContent={"space-between"}
      borderBottom={"1px solid #31313127"}
      bgcolor={isLongHeader ? color.white : color.background}
    >
      <Container
        maxWidth={isLongHeader ? "lg" : "md"}
        sx={{
          height: "90px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Toolbar disableGutters>
          <Box flexGrow={1} display={{ xs: "flex", md: "none" }}>
            <Box>
              {logo === "NFTYDoor" ? (
                <CLogo />
              ) : logo === "fortuna" ? (
                <CCustomLogo link={""} logo={FortunaLogo} />
              ) : (
                <CCustomLogo link={link} logo={logo} />
              )}
            </Box>
            <Drawer
              open={opened}
              anchor="left"
              variant="persistent"
              sx={{
                flexShrink: 0,
                "& .MuiDrawer-paper": {
                  top: "90px",
                  width: "100%",
                  boxSizing: "border-box",
                  backgroundColor: color.purple,
                },
              }}
            >
              <Box
                px={3}
                pt={3}
                display="flex"
                alignItems={{ md: "center", xs: "start" }}
                flexDirection={{ xs: "column", md: "row" }}
              >
                <CFaqsButton pathname={pathname} />
                {!isTracker ? (
                  <CContactusButton pathname={pathname} />
                ) : (
                  <CContactusGladlyButton />
                )}
                {isLogin && !user && <CGetintouchButton />}
                {!isLogin && !user && !isSignupForm && (
                  <CLoginButton isLender={isLender} />
                )}
                {!isLogin && !user && !isLender && !isSignupForm && (
                  <CForlendersButton isLongHeader={isLongHeader} />
                )}
                <Box sx={{ display: { xs: "none", md: "flex" } }}>
                  <CAvatar />
                </Box>
              </Box>
            </Drawer>
          </Box>
        </Toolbar>

        <Box
          alignItems={"center"}
          display={{ xs: "flex", md: "none" }}
          sx={{ WebkitTapHighlightColor: "transparent" }}
        >
          <Box mr={4}>
            <CAvatar />
          </Box>
          <Box m={-1}>
            <Hamburger
              size={30}
              toggled={opened}
              toggle={setOpened}
              color={color.purple}
            />
          </Box>
        </Box>

        <Box
          flexGrow={1}
          alignItems={"center"}
          justifyContent={"space-between"}
          display={{ xs: "none", md: "flex" }}
        >
          {logo === "NFTYDoor" ? (
            <CLogo />
          ) : logo === "fortuna" ? (
            <CCustomLogo link={""} logo={FortunaLogo} />
          ) : (
            <CCustomLogo link={link} logo={logo} />
          )}
          <Box
            display="flex"
            alignItems={{ md: "center", xs: "start" }}
            flexDirection={{ xs: "column", md: "row" }}
          >
            <CFaqsButton pathname={pathname} />
            {!isTracker ? (
              <CContactusButton pathname={pathname} />
            ) : (
              <CContactusGladlyButton />
            )}
            {isLogin && !user && <CGetintouchButton />}
            {!isLogin && !user && !isSignupForm && (
              <CLoginButton isLender={isLender} />
            )}
            {!isLogin && !user && !isLender && !isSignupForm && (
              <CForlendersButton isLongHeader={isLongHeader} />
            )}
            <Box sx={{ display: { xs: "none", md: "flex" } }}>
              <CAvatar />
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default CHeader;
